export default __webpack_public_path__ + "static/NXL-hero-bg-full-words-mobile-67466760e107da6aed77986c505b2996.jpg";